import ApiClient from "@/api/client/ApiClient";

ApiClient.setBaseUrl(process.env.VUE_APP_API_ENDPOINT as string);
ApiClient.setRateLimits(Number(process.env.VUE_APP_API_RATE_LIMIT_REQUESTS), Number(process.env.VUE_APP_API_RATE_LIMIT_WINDOW));
